import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import brimleyCountries from './locale/brimley/countries.json'
import brimleyTranslation from './locale/brimley/localization.json'
import flightCountries from './locale/flight/countries.json'
import flightTranslation from './locale/flight/localization.json'
import impactCountries from './locale/impact/countries.json'
import impactTranslation from './locale/impact/localization.json'
import windrunnerCountries from './locale/windrunner/countries.json'
import windrunnerTranslation from './locale/windrunner/localization.json'

const defaultLocalization = process.env.REACT_APP_LOCALIZATION ?? 'windrunner'

i18n
  .use(initReactI18next)
  .init({
    lng: defaultLocalization,
    fallbackLng: 'windrunner',
    debug: true,
    interpolation: {
      escapeValue: false
    },
    resources: {
      windrunner: {
        translation: {
          ...windrunnerTranslation,
          countries: windrunnerCountries
        }
      },
      impact: {
        translation: {
          ...impactTranslation,
          countries: impactCountries
        }
      },
      brimley: {
        translation: {
          ...brimleyTranslation,
          countries: brimleyCountries
        }
      },
      flight: {
        translation: {
          ...flightTranslation,
          countries: flightCountries
        }
      }
    }
  })

export default i18n
